import { useMemo } from "react"
import camelcaseKeys from "camelcase-keys"

/**
 * Transform flashcard props from Rails snake_case to React camelCase
 * Use this hook in flashcard pages to convert prop keys automatically
 */
export function useFlashcardProps<T>(props: any): T {
  return useMemo(() => camelcaseKeys(props, { deep: true }) as T, [props])
}
